import { Component, OnInit } from '@angular/core';
import { AllMessengersService } from '../page-start/all-messengers.service';
import { InterfaceService } from '../../services/interface.service';
import { LeadsService } from '../../modules/leads/services/leads.service';
import { SenderService } from '../../services/sender.service';

@Component({
  selector: 'app-page-scan-tasks',
  templateUrl: './page-scan-tasks.component.html',
  styleUrls: ['./page-scan-tasks.component.scss']
})
export class PageScanTasksComponent implements OnInit {

  constructor(
    public leadsService: LeadsService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
    public allMessengersService: AllMessengersService
    ) { }

  ngOnInit(): void {
  }
}
